import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import App from './app.vue'
import axios from 'axios'

// directives
import VTooltip from 'v-tooltip'
import infiniteScroll from 'vue-infinite-scroll'
import Datepicker from 'vuejs-datepicker'
import PostFeed from '@router/components/post-feed.vue'
import Vuelidate from 'vuelidate'
// wysiwyg
import wysiwyg from 'vue-wysiwyg'

// LoadScript
import LoadScript from 'vue-plugin-load-script'

// Globally register all `_base`-prefixed components
import '@components/_globals'

import { setBugsnaVuePlugin } from '@utils/setup-bugsnag'

// axios baseURL
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

setBugsnaVuePlugin(Vue)

Vue.use(infiniteScroll)
Vue.use(wysiwyg)
Vue.use(Vuelidate)
Vue.use(PostFeed)
Vue.use(Datepicker)
Vue.use(VTooltip)
Vue.use(LoadScript)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
